import { render, staticRenderFns } from "./webrtcVideo.vue?vue&type=template&id=5c25c04f&scoped=true"
import script from "./webrtcVideo.vue?vue&type=script&lang=js"
export * from "./webrtcVideo.vue?vue&type=script&lang=js"
import style0 from "./webrtcVideo.vue?vue&type=style&index=0&id=5c25c04f&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c25c04f",
  null
  
)

export default component.exports